import type { CSSProperties } from "react";
import { spacing } from "@atlas-int/tokens";

export const scatterplotOuterStyle: CSSProperties = {
  display: "flex",
  height: "100%",
  width: "100%",
  alignItems: "center",
  position: "relative",
  justifyContent: "flex-start",
};

export const scatterplotInnerStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  marginLeft: spacing[16],
  position: "relative",
  zIndex: 1,
};
